export const GRAFANA_APP = 'pro_migration';

export const SeamlessModalEventType = {
    EntryPointModalIsShown: 'fip_registration_entry_point_pop_up_is_shown',
    ClickedEntryPointStart: 'clicked_on_fip_registration_entry_point_start',
    ClickedEntryPointClose: 'clicked_on_fip_registration_entry_point_close',
};
